import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgVk(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        d="M17.098 24.2667C8.04517 24.2667 2.88165 18.0605 2.6665 7.7334H7.20116C7.35011 15.3133 10.6931 18.5239 13.3411 19.1859V7.7334H17.6111V14.2706C20.226 13.9892 22.973 11.0103 23.8997 7.7334H28.1698C27.4581 11.7716 24.4791 14.7505 22.3607 15.9752C24.4791 16.9682 27.872 19.5666 29.1629 24.2667H24.4626C23.453 21.1223 20.9376 18.6894 17.6111 18.3584V24.2667H17.098Z"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgVk);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
